<ng-container *ngIf="loaded">
  <div class="card">
    <div class="card-body">
      <div class="row no-gutters d-flex">
        <div class="col-md-3">
          <img class="img-fluid br-5" src="https://proddevops.blob.core.windows.net/pubweb/marketplace/images/images/happy-guy-with-machine.jpg" />
        </div>
        <div class="col-md-8">
          <div class="card-body">
            <h3>Rent to Sell</h3>
            <p class="section-header font-weight-light">
              The Rubbl Rent to Sell program is a great way to get top dollar for your equipment. We have the lowest conversion fee of 7.5%. Forget about
              auctions, let Rubbl help you rent and sell your equipment.
            </p>
            <small></small>
            <small class="text-muted"
              >Use the calculator below to set your sale price and review your potential earnings. For detailed information about the Rubbl Rental Purchase
              Option <a target="_blank" href="https://support.rubbl.com/selling-equipment-overview">click here</a>.</small
            >
          </div>

          <div class="card-body">
            <h4 class="mr-4">Do you want to offer Rent to Sell for this machine?</h4>
            <div class="form-group">
              <div class="form-check form-check-inline radio-button">
                <common-radio-button [id]="'attachment-modal-single-item-select'" groupName="rpo" label="Yes" [value]="true" [(model)]="entity.rpoEnabled">
                </common-radio-button>
              </div>
              <div class="form-check form-check-inline radio-button">
                <common-radio-button [id]="'attachment-modal-type-select'" groupName="rpo" label="No" [value]="false" [(model)]="entity.rpoEnabled">
                </common-radio-button>
              </div>
            </div>
            <div class="col-lg-3" *ngIf="!entity.rpoEnabled">
              <button class="btn btn-secondary btn-mobile btn-block" (click)="save()">Save</button>
            </div>
          </div>
        </div>
      </div>
      <div class="list-group mt-3" *ngIf="entity.rpoEnabled">
        <div class="list-group-item d-lg-flex align-items-center">
          <div class="col-lg-6">
            <p class="mb-1">Rent To Sell Starting Price</p>
            <p class="fs-14 font-weight-light mb-0">
              We recommend the RPO Price should be set 5% to 10% higher than your cash sale price or replacement (insurance) value.
            </p>
          </div>
          <div class="col-lg-4 offset-lg-1 justify-content-center d-flex">
            <div class="form-group d-flex align-items-baseline mb-0">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">$</span>
                </div>
                <input
                  class="form-control"
                  [(ngModel)]="entity.purchasePrice"
                  (keyup)="onPurchasePriceChange($event.target.value)"
                  type="text"
                  mask="separator"
                  thousandSeparator=","
                  [maxLength]="9"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="list-group-item d-lg-flex align-items-center">
          <div class="col-lg-6">
            <p class="mb-1">Monthly Rental Rate</p>
            <p class="fs-14 font-weight-light mb-0">Your monthly rental rate will be used to calculate the monthly rental deduction.</p>
          </div>
          <div class="col-lg-6 text-center">
            <p class="mb-1">{{ entity.rentalRate | currency: "USD":"symbol":"1.0-0" }}</p>
          </div>
        </div>
        <div class="list-group-item d-lg-flex align-items-center">
          <div class="col-lg-6">
            <p class="mb-1">Simulate Rental Duration</p>
            <p class="fs-14 font-weight-light mb-0">The RPO option will be available to the renter for a max of 6 months.</p>
          </div>
          <div class="col-lg-4 offset-lg-1 d-flex justify-content-center">
            <div class="form-group d-flex align-items-baseline mb-0">
              <select class="form-control" (change)="rentalDurationChange($event.target.value)">
                <option value="1">1 month</option>
                <option value="2">2 months</option>
                <option value="3">3 months</option>
                <option value="4">4 months</option>
                <option value="5">5 months</option>
                <option value="6">6 months</option>
              </select>
            </div>
          </div>
        </div>
        <div class="list-group-item d-lg-flex align-items-center" *ngFor="let row of comparisonTable.rows">
          <div class="col-lg-6">
            <p class="mb-1" [innerHtml]="row.columns[0].label"></p>
          </div>
          <div class="col-lg-6 text-center">
            <p class="mb-1" [innerHtml]="row.columns[1].label"></p>
          </div>
        </div>
        <div class="list-group-item d-flex align-items-center">
          <div class="col-md-6 offset-md-6">
            <button class="btn btn-secondary btn-mobile btn-block" (click)="save()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
